import type {CSSObject} from "@emotion/react";
import styled from "@emotion/styled";

export const ContentWrapper = styled.div<{styles?: CSSObject}>(({theme, styles}) => ({
  gridColumn: theme?.breakpoints?.isMobile
    ? "1/-1"
    : theme?.breakpoints?.md
      ? "3/15"
      : "4/14",
  ...styles,
}));
